import React, { SVGProps } from 'react'
const SvgActionRequired = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={121}
    height={135}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#ActionRequired_svg__a)">
      <path
        fill="#EAEBF1"
        fillRule="evenodd"
        d="m150.293 40.456-35.657 12.977a1.409 1.409 0 0 0-.843 1.806l.674 1.852a1.409 1.409 0 0 0 1.806.841l35.657-12.978a1.41 1.41 0 0 0 .843-1.805l-.674-1.852a1.409 1.409 0 0 0-1.806-.841ZM53.836 51.974 29.15 60.958a1.409 1.409 0 0 0-.843 1.805l.675 1.853a1.409 1.409 0 0 0 1.805.84l24.685-8.984a1.409 1.409 0 0 0 .843-1.805l-.675-1.852a1.409 1.409 0 0 0-1.805-.841ZM132.237 1.09l-13.712 4.991a1.41 1.41 0 0 0-.843 1.805l.675 1.852a1.408 1.408 0 0 0 1.805.842l13.713-4.991a1.409 1.409 0 0 0 .842-1.805l-.674-1.853a1.409 1.409 0 0 0-1.806-.84Z"
        clipRule="evenodd"
      />
      <g filter="url(#ActionRequired_svg__b)">
        <path
          fill={props.fill || 'var(--color-cta)'}
          d="M67.11-8.368a4.34 4.34 0 0 1 3.156-1.148l46.475 2.225a4.421 4.421 0 0 1 3.933 2.913l7.479 20.547c10.297 28.292 2.621 59.905-19.432 80.04a4.341 4.341 0 0 1-3.11 1.131c-29.837-1.248-56.037-20.532-66.334-48.823L31.799 27.97a4.422 4.422 0 0 1 1.14-4.76L67.111-8.367Z"
        />
        <path
          fill="#3475F2"
          d="M65.922-9.652 31.75 21.926l-.207.201a6.19 6.19 0 0 0-1.39 6.443l7.478 20.546.317.856c10.766 28.511 37.367 47.853 67.589 49.117a6.09 6.09 0 0 0 4.364-1.588c22.58-20.615 30.436-52.976 19.897-81.931L122.32-4.977l-.106-.27c-.945-2.218-3.03-3.679-5.388-3.792l-46.475-2.225-.376-.007a6.092 6.092 0 0 0-4.053 1.619ZM70.01-7.77l.224.004 46.421 2.223a2.669 2.669 0 0 1 2.318 1.627l.071.182 7.462 20.502c10.056 27.627 2.561 58.494-18.967 78.149a2.589 2.589 0 0 1-1.855.675c-28.816-1.206-54.188-19.654-64.456-46.847l-.31-.837-7.475-20.537a2.675 2.675 0 0 1 .58-2.775l.139-.134L68.299-7.083a2.586 2.586 0 0 1 1.51-.676l.202-.011Z"
        />
        <g filter="url(#ActionRequired_svg__c)">
          <path
            fill="#F6F7FB"
            fillRule="evenodd"
            d="M81.239 13.501a3.94 3.94 0 0 0-4.81-1.82 3.94 3.94 0 0 0-2.357 5.048l12.883 35.396.24.532a3.94 3.94 0 0 0 4.81 1.82 3.94 3.94 0 0 0 2.356-5.047L81.478 14.034l-.24-.533Zm17.982 49.28a3.94 3.94 0 0 0-4.81-1.82 3.94 3.94 0 0 0-2.357 5.048l.76 2.087.238.532a3.94 3.94 0 0 0 4.811 1.82 3.94 3.94 0 0 0 2.357-5.048l-.76-2.086-.24-.532Z"
            clipRule="evenodd"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="ActionRequired_svg__b"
        width={124.638}
        height={130.365}
        x={19.779}
        y={-17.271}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_30_4041" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_30_4041"
          result="shape"
        />
      </filter>
      <filter
        id="ActionRequired_svg__c"
        width={46.625}
        height={79.245}
        x={63.833}
        y={5.442}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_30_4041" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_30_4041"
          result="shape"
        />
      </filter>
      <clipPath id="ActionRequired_svg__a">
        <path fill="#fff" d="M0 0h121v135H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgActionRequired
